<template>
  <div>
    <div class="area-header --uppercase">{{ $t('ui.riskAnalysis.title') }}</div>
    <div class="purple-box indicator-container">
      <div class="--capitalise-first-letter">{{ $t('ui.riskAnalysis.relativeStrengthToOpponent') }}:</div>
      <div id="risk-key">
        <div class="risk-key-label --capitalise-first-letter">{{ $t('ui.riskAnalysis.muchWorse') }}</div>
        <div class="risk-key-label --capitalise-first-letter --align-center">{{ $t('ui.riskAnalysis.aboutTheSame') }}</div>
        <div class="risk-key-label --capitalise-first-letter --align-right">{{ $t('ui.riskAnalysis.muchBetter') }}</div>
      </div>
      <div class="bar-label --capitalise-first-letter">
        <span>{{ $t('tactics.possession.inPossession')}}</span>
        <span v-if="!production">: {{ inPossession.score }}</span>
      </div>
      <RiskIndicatorBar :riskPercent="inPossession.percent" />
      <div class="bar-label --capitalise-first-letter">
        <span>{{ $t('tactics.possession.outOfPossession') }}</span>
        <span v-if="!production">: {{ outOfPossession.score }}</span>
      </div>
      <RiskIndicatorBar :riskPercent="outOfPossession.percent" />
      <div class="bar-label --capitalise-first-letter">
        <span>{{ $t('ui.riskAnalysis.total') }}</span>
        <span v-if="!production">: {{ total.score }}</span>
      </div>
      <RiskIndicatorBar :riskPercent="total.percent" />
    </div>
  </div>
</template>

<script>
import RiskIndicatorBar from './RiskIndicatorBar.vue';

export default {
  components: {
    RiskIndicatorBar,
  },

  data: function() {
    return {
      production: process.env.NODE_ENV !== "development",
    };
  },

  computed: {
    inPossession() {
      const playingStyleAnalysis = this.$store.getters.playingStyleAnalysis;
      const maxPoss = 75;
      const score = playingStyleAnalysis.netInPossessionScore;
      const percent = Math.min(Math.max((score + maxPoss) / (maxPoss * 2) * 100, 0), 100);
      return {
        score,
        percent,
      }
    },

    outOfPossession() {
      const playingStyleAnalysis = this.$store.getters.playingStyleAnalysis;
      const maxPoss = 40;
      const score = playingStyleAnalysis.netOutOfPossessionScore;
      const percent = Math.min(Math.max((score + maxPoss) / (maxPoss * 2) * 100, 0), 100);
      return {
        score,
        percent,
      }
    },

    total() {
      const playingStyleAnalysis = this.$store.getters.playingStyleAnalysis;
      const maxPoss = 120;
      const score = playingStyleAnalysis.netInPossessionScore + playingStyleAnalysis.netOutOfPossessionScore
      const percent = Math.min(Math.max((score + maxPoss) / (maxPoss * 2) * 100, 0), 100);
      return {
        score,
        percent,
      }
    },
  }
}
</script>

<style scoped>
.indicator-container {
  padding: 12px;
  margin-top: -8px;
}

.bar-label {
  margin: 8px 8px 4px;
}

#risk-key {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
}

.risk-key-label {
  display: inline-block;
  font-style: italic;
}

.--align-center {
  text-align: center;
}

.--align-right {
  text-align: right;
}
</style>
